export default { sha: '3edeacff17e994a0585599e311fd12c2f887be39', buildNumber: 'undefined' }
